import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state(){
		return{
			uobj:'',
			NavHistoyLObj:'',
			solelist:'',
			tablist:[],
			setHistTabsValue:''
		}
	},
  mutations: {
	setUser(state,obj){//写入用户信息
		state.uobj=obj
	},
	setNavHistoy(state,obj){//写入历史标签选中数据
		state.NavHistoyLObj=obj
	},
	setSole(state,obj){//写入权限数组
		state.solelist=obj
	},
	upEditableTabs(state,obj){//修改历史标签
		state.tablist=obj
	},
	setHistTabsValue(state,obj){//历史选中
		state.setHistTabsValue=obj
	}
  },
  actions: {
  },
  modules: {
  }
})